import {
    getChildTicket,
    getTicketByCategoryAndType,
} from '../../utils/tickets';
import { createReducer } from './create';

const initialState = {
    tickets: [],
    ticket_types: [],
    selected_ticket: null,
    selected_ticket_type: null,
    added_tickets: [],
    added_tickets_per_type: [],
    confirmed_tickets: [],
    confirmed_tickets_desktop: false,

    step_show_confirm_ticket: false,
    step_tickets_done: false,
};

export default createReducer(initialState, {
    ['APP/CLEAR']: () => {
        return initialState;
    },
    ['APP/SOFT_CLEAR']: (state) => {
        return Object.assign({}, initialState, {
            tickets: state.tickets,
            ticket_types: state.ticket_types,
        });
    },
    ['PACKAGES/SELECT']: (state, payload) => {
        const tickets = payload.package.tickets;
        const ticketTypes = [];
        for (let i = 0, l = tickets.length, ticket; i < l; ++i) {
            ticket = tickets[i];

            if (
                ticket.type == null
                || ticketTypes.find(t => t.name === ticket.type)
            ) {
                continue;
            }

            ticketTypes.push({
                name: ticket.type,
                locked: ticket.locked,
            });
        }

        ticketTypes.sort((a, b) => {
            if (a.name.toLowerCase().indexOf('vuxen') > -1) {
                return -1;
            } else if (b.name.toLowerCase().indexOf('vuxen') > -1) {
                return 1;
            }

            if (a.locked) {
                return 1;
            } else if (b.locked) {
                return -1;
            }

            return 0;
        });

        return {...state, tickets, ticket_types: ticketTypes};
    },
    ['TICKETS/SELECT']: (state, payload) => {
        if (state.selected_ticket === payload.ticket) {
            return state;
        }

        return Object.assign({}, state, {
            added_tickets: [],
            selected_ticket: payload.ticket,
        });
    },
    ['TICKETS/SELECT_TYPE']: (state, payload) => {
        const ticketType = payload !== state.selected_ticket_type
            ? payload
            : null;

        const isAdultTicketType = ticketType == null ||
            ticketType.toLowerCase() === 'vuxen' ||
            ticketType.toLowerCase().indexOf('senior') > -1;

        let selectedTicket = null;
        if (state.added_tickets.length > 0) {
            // Make sure that any selected ticket always has the same category as
            // the already added ones.
            if (isAdultTicketType) {
                selectedTicket = getTicketByCategoryAndType(
                    state.tickets,
                    state.added_tickets[0].category,
                    ticketType,
                );
            } else {
                const parentTicket = state.added_tickets.find(t => !t.locked);
                selectedTicket = parentTicket != null
                    ? getChildTicket(
                        state.tickets,
                        parentTicket.category,
                        ticketType,
                    )
                    : null;
            }
        }

        return Object.assign({}, state, {
            selected_ticket: selectedTicket,
            selected_ticket_type: ticketType,
        });
    },
    ['TICKETS/ADD_SINGLE']: (state, payload) => {
        return Object.assign({}, state, {
            added_tickets: [...state.added_tickets, payload.ticket],
            food: state.food == null
            && payload.ticket.food != null
                ? payload.ticket.food
                : state.food != null
                    ? state.food
                    : null,
        });
    },
    ['TICKETS/REMOVE']: (state, payload) => {
        const index = state.added_tickets.indexOf(payload.ticket);
        let addedTickets = []
            .concat(state.added_tickets.slice(0, index))
            .concat(state.added_tickets.slice(index + 1));

        const containsLockedTickets = addedTickets.find(t => t.locked);
        const containsUnlockedTickets = addedTickets.find(t => !t.locked);

        if (containsLockedTickets && !containsUnlockedTickets) {
            addedTickets = [];
        }

        return Object.assign({}, state, {
            added_tickets: addedTickets,
        });
    },
    ['TICKETS/CONFIRM']: (state, payload) => {
        return Object.assign({}, state, {
            confirmed_tickets: payload.confirmed_tickets,
        });
    },
    ['TICKETS/DESELECT_CONFIRMED_TICKETS']: (state) => {
        return {...state, confirmed_tickets: []};
    },
});
